import { BindingCreator } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

type CurrentPractitionerCheckboxFieldName = 'diagnosedByCurrentPractitioner';
type CurrentPractitionerCheckboxType = boolean;

export type CurrentPractitionerCheckboxFormBeanPart = {
   [key in CurrentPractitionerCheckboxFieldName]: CurrentPractitionerCheckboxType;
};

type CurrentPractitionerCheckboxProps<FIELD_NAME extends CurrentPractitionerCheckboxFieldName> = {
   readonly register: BindingCreator<CurrentPractitionerCheckboxFormBeanPart>;
   readonly handleSelectionChange: (selection: boolean) => void;
   readonly name: FIELD_NAME;
   readonly label: string;
};

export const CurrentPractitionerCheckbox = <FIELD_NAME extends CurrentPractitionerCheckboxFieldName>(
   props: CurrentPractitionerCheckboxProps<FIELD_NAME>
): JSX.Element => {
   return (
      <Checkbox
         onSelectionChange={props.handleSelectionChange}
         controller={props.register(props.name)}
         testId={'currentPractitionerCheckbox'}
         label={props.label}
         compact
      />
   );
};
